import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var ArrowLeftIcon = function () { return (jsxs("svg", __assign({ width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "Arrow left" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.10614 5.00172L7.17212 0.785996L6.1612 0.0507812L2.56051 5.00172L6.1612 9.95266L7.17212 9.21745L4.10614 5.00172Z", fill: "currentColor" })] }))); };

export { ArrowLeftIcon };
